import React from 'react'
import Navbar from '../Home/Navbar';
import Brand from '../About/Brand';
import Footer from '../Home/Footer';
import Product from './Product';
import { CartProvider } from 'react-use-cart';

function AllShop() {
  return (
    <CartProvider>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <Product/>
        <Brand/>
        <Footer/>
    </CartProvider>
  )
}

export default AllShop;